/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ConstructionSitesService } from '@app/customers/services/construction-sites.service';
import * as ConstructionSiteActions from '@construction-sites/store/construction-sites.actions';
import { State } from '@core/store';
import { Store } from '@ngrx/store';
import { ConstructionSite } from '@shared/models';
import { Observable } from 'rxjs';
import { filter, map, tap, withLatestFrom } from 'rxjs/operators';

const isObject = (value: unknown): value is object => value !== null && typeof value === 'object';

@Component({
    selector: 'app-construction-site-search',
    templateUrl: './construction-site-search.component.html',
    styleUrls: ['./construction-site-search.component.scss'],
    standalone: false
})
export class ConstructionSiteSearchComponent implements OnInit {
  @Input() control = new UntypedFormControl();
  @ViewChild('trigger', { static: true }) trigger: MatAutocompleteTrigger;

  filteredConstructionSites$: Observable<ConstructionSite[]>;

  constructor(private constructionSiteService: ConstructionSitesService, private store: Store<State>) { }

  ngOnInit(): void {
    this.control.parent.get('customer').valueChanges.pipe(
      filter(customer => isObject(customer)),
      tap(customer => this.filterConstructionSites(customer))
    ).subscribe();
  }

  private filterConstructionSites(customer): void {
    this.filteredConstructionSites$ = this.control.valueChanges.pipe(
      withLatestFrom(this.constructionSiteService.getActiveConstructionSitesFor(customer.id)),
      map(([searchText, constructionSites]) => {
        if (false === isObject(searchText)) {
          searchText = searchText.toLowerCase();
          const filteredConstructionSites = constructionSites.filter(
            constructionSite => constructionSite.name.toLowerCase().includes(searchText)
          );

          if (filteredConstructionSites.length === 1 && filteredConstructionSites[0].name.toLowerCase() === searchText) {
            this.control.setValue(filteredConstructionSites[0]);
          }

          return filteredConstructionSites;
        } else {
          this.store.dispatch(new ConstructionSiteActions.SetCurrentConstructionSite(searchText as ConstructionSite));
        }
      })
    );
  }

  displayConstructionSite(constructionSite?: ConstructionSite): string {
    return constructionSite ? constructionSite.name : '';
  }

  onFocus(): void {
    this.trigger._onChange(this.control.value);
    this.trigger.openPanel();
  }
}
